module.exports = __webpack_public_path__ + "img/logo.460f4ae5.png";